import { render, staticRenderFns } from "./ConfigList.vue?vue&type=template&id=2ac9b3c0&scoped=true&"
import script from "./ConfigList.vue?vue&type=script&lang=js&"
export * from "./ConfigList.vue?vue&type=script&lang=js&"
import style0 from "./ConfigList.vue?vue&type=style&index=0&id=2ac9b3c0&scoped=true&lang=css&"
import style1 from "./ConfigList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ac9b3c0",
  null
  
)

export default component.exports